import CloseIcon from '@mui/icons-material/Close';
import { Button, DialogActions, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { Formik } from 'formik';
import { Listing } from 'graphql/generated';
import { WsFormTextField } from 'stories/forms/WsFormTextField';
import WsButton from 'stories/inputs/WsButton';
import WsFormBox from 'stories/layout/WsFormBox';
import WsFormInfoContainer from 'stories/layout/WsFormInfoContainer';
import WsGridContainer from 'stories/layout/WsGridContainer';
import WsPanel from 'stories/layout/WsPanel';
import * as yup from 'yup';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  h: 600,
}));

export interface ContactSellerProps {
  children?: React.ReactNode;
  onClose: (ack: boolean) => void;
}

const BootstrapContactSellerTitle = (props: ContactSellerProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle color="primary" sx={{ m: 0, pl: 3, pb: 0 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={() => onClose(false)}
          size="large"
          sx={{
            position: 'absolute',
            right: 12,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export interface ConfirmDialogProps {
  open: boolean;
  carDescription: string;
  closeAction: (ack: boolean, message?: string) => void;
}

interface FormValues {
  message: string;
}

const validationSchema = yup.object().shape({
  message: yup.string().required('Required'),
});

export default function ContactSellerDialog(props: ConfirmDialogProps) {
  const formAction = async (formValues: FormValues, setSubmitting: (isSubmitting: boolean) => void) => {
    props.closeAction(true, formValues.message);
  };

  return (
    <BootstrapDialog
      fullWidth={true}
      maxWidth="xs"
      open={props.open}
      onClose={props.closeAction}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <BootstrapContactSellerTitle onClose={props.closeAction}>Contact Seller</BootstrapContactSellerTitle>
      <WsGridContainer>
        <Formik
          validationSchema={validationSchema}
          // validate={validateForm}
          initialValues={{
            message: `Hi, I would like to learn more about the ${props.carDescription} for sale.`,
          }}
          onSubmit={(values, { setSubmitting }) => formAction(values, setSubmitting)}
        >
          {formik => (
            <>
              <form onSubmit={formik.handleSubmit}>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
                  <WsFormInfoContainer sx={{ pl: 1, pr: 1 }}>
                    Use the default, or customize the message to send to the seller. Your account email will be included
                    to allow the seller to respond directly to you.
                  </WsFormInfoContainer>
                  <WsFormTextField
                    id="message"
                    multiline
                    variant="outlined"
                    width={400}
                    sx={{ minHeight: 140 }}
                    rows={6}
                    maxLength={512}
                    formik={formik}
                    isx={{ padding: 1 }}
                  />
                  {/* <Grid container justifyContent="center" width={'80%'}>
                    <Grid container>
                      <WsFormInfoContainer>
                        Passwords must contain at least 8 characters, including at least one uppercase letter, one
                        lowercase letter, and one number or special symbol (1,2,3,#,&,%,etc.).
                      </WsFormInfoContainer>
                      <WsFormBox>
                        <WsFormTextField
                          id="message"
                          multiline
                          variant="outlined"
                          width={360}
                          rows={4}
                          maxLength={240}
                          formik={formik}
                          isx={{ padding: 1 }}
                        />
                      </WsFormBox>
                    </Grid>
                  </Grid> */}
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => props.closeAction(false)}>Cancel</Button>
                  <Button type="submit" autoFocus>
                    Send Message
                  </Button>
                </DialogActions>
              </form>
            </>
          )}
        </Formik>
      </WsGridContainer>
    </BootstrapDialog>
  );
}
